import { Link } from 'react-router-dom';
import { Truck, Shield, FileText, Cookie, ScrollText, LifeBuoy } from 'lucide-react';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-gray-200 bg-white mt-12">
      <div className="w-full px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 font-bold text-blue-600 text-base mb-2">
              <Truck className="w-5 h-5" />
              TransitDeal
            </div>
            <p className="text-xs text-gray-500 leading-relaxed">
              The UK's transport marketplace — connecting customers with vetted drivers,
              hauliers, and workshops for fast, transparent deliveries.
            </p>
          </div>

          {/* Platform links */}
          <div>
            <p className="text-xs font-semibold text-gray-700 uppercase tracking-wide mb-3">Platform</p>
            <ul className="space-y-2">
              {[
                { to: '/jobs',       label: 'Find Jobs' },
                { to: '/post-job',   label: 'Post a Job' },
                { to: '/register',   label: 'Create Account' },
                { to: '/chatbot',    label: 'AI Assistant' },
                { to: '/help',       label: 'Help & How-To Guide', icon: <LifeBuoy className="w-3.5 h-3.5" /> },
              ].map(l => (
                <li key={l.to}>
                  <Link to={l.to} className="flex items-center gap-1.5 text-xs text-gray-500 hover:text-blue-600 transition-colors">
                    {l.icon}{l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal links */}
          <div>
            <p className="text-xs font-semibold text-gray-700 uppercase tracking-wide mb-3">Legal</p>
            <ul className="space-y-2">
              {[
                { to: '/privacy',       label: 'Privacy Policy',        icon: <Shield className="w-3.5 h-3.5" />,    external: false },
                { to: '/terms',         label: 'Terms & Conditions',    icon: <FileText className="w-3.5 h-3.5" />,  external: false },
                { to: '/cookies',       label: 'Cookie Policy',         icon: <Cookie className="w-3.5 h-3.5" />,    external: false },
                { to: '/policies/website-usage-policy.html', label: 'Website & App Usage Policy', icon: <ScrollText className="w-3.5 h-3.5" />, external: true },
              ].map(l => (
                <li key={l.to}>
                  {l.external ? (
                    <a
                      href={l.to}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-1.5 text-xs text-gray-500 hover:text-blue-600 transition-colors"
                    >
                      {l.icon}{l.label}
                    </a>
                  ) : (
                    <Link
                      to={l.to}
                      className="flex items-center gap-1.5 text-xs text-gray-500 hover:text-blue-600 transition-colors"
                    >
                      {l.icon}{l.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-100 pt-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-gray-400">
          <div className="space-y-0.5">
            <p>© {year} TransitDeal Ltd. All rights reserved.</p>
            <p>Registered in England &amp; Wales · Company No. [COMPANY_REG_NO]</p>
          </div>
          <div className="text-right space-y-0.5">
            <p>Regulated data use · ICO Reg. [ICO_REG_NO]</p>
            <p>
              Questions?{' '}
              <a href="mailto:privacy@transitdeal.co.uk" className="text-blue-500 hover:underline">
                privacy@transitdeal.co.uk
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
